import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const City = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseInput
      name="city"
      label="City"
      type="text"
      autoComplete="off"
      transparent
      validate={val =>
        string()
          .required('Enter a valid city')
          .min(2, 'City must be greater than 2 characters')
          .max(100, 'City cannot be greater than 100 characters')
          .validate(val)
          .then(() => null)
          .catch(err => err.errors.join(', '))
      }
      {...props}
      data-cv-test-override={dataCvTest || 'addressCity'}
    />
  );
};

City.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

City.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default City;
